import { getFormatStr } from './formatters';
export function formatNumber(formatters, spec) {
    if (!spec || typeof spec.value === 'undefined') {
        console.warn('formatNumber requires "value" property defined');
        return null;
    }
    var value = spec.value, decimals = spec.decimals, maxDecimals = spec.maxDecimals;
    var options = { decimals: decimals, maxDecimals: maxDecimals };
    var formattedValue = value;
    if (typeof value === 'string') {
        formattedValue = parseFloat(value);
    }
    var _a = formatters.preferences, locale = _a.locale, numberFormat = _a.numberFormat;
    var numberFmtStr = getFormatStr(numberFormat.numberSign, options);
    return formatters.getNumeralFormatter(locale, numberFormat)(formattedValue).format(numberFmtStr);
}
